import { mediaBreakpointMixin, spaceMixin, Table, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import { PROPERTY_ROW_WIDTHS } from '../../soh/PropertyRow/StyledComponents';

export const StyledTableContainer = styled(Table.Responsive)`
  ${({ isZram }) =>
    isZram
      ? css`
          border: 1px solid ${token('colors.gray300')};
        `
      : css`
          border-top: 1px solid ${token('colors.gray300')};
        `}
  border-radius: ${({ isZram }) => (isZram ? '2px' : css`0 0 ${spaceMixin('xs')} ${spaceMixin('xs')}`)};
  margin-bottom: ${({ isZram }) => (isZram ? spaceMixin(3) : '0')};
`;

export const StyledTable = styled(Table)`
  table-layout: ${({ isZram }) => (isZram ? 'auto' : 'fixed')};
`;

export const StyledTableHeader = styled(Table.Header)`
  display: block;
  background: ${token('colors.gray200')};
  border-top: 1px solid ${token('colors.borderLight')};
  padding: ${({ isVisible }) =>
    isVisible
      ? '0'
      : css`
          0 ${spaceMixin('md')}
        `};
`;

export const StyledTableHeaderCell = styled(Table.HeaderCell)<{
  isZram?: boolean;
}>`
  ${({ isZram = true }) =>
    !isZram &&
    css`
      &&&:first-child {
        padding-left: ${spaceMixin('md')};
        width: ${PROPERTY_ROW_WIDTHS.FIRST_CELL};
      }

      &&& {
        padding: ${spaceMixin('xs')};
        width: ${PROPERTY_ROW_WIDTHS.MIDDLE_CELL};
        font-weight: ${token('fontWeights.bodySmallHeading')};
        font-size: ${token('fontSizes.bodySmallHeading')}px;
      }

      &&&:last-child {
        width: ${PROPERTY_ROW_WIDTHS.LAST_CELL};
      }
    `}

  && {
    @media ${mediaBreakpointMixin('md')} {
      padding: ${spaceMixin('sm')} 0 ${spaceMixin('sm')} ${spaceMixin('sm')};
      min-width: 106px;

      ${({ isZram = true }) => css`
        &:last-child {
          ${isZram ? `padding-right: ${spaceMixin('sm')};` : `min-width: auto;`}
        }
      `}
    }

    ${({ isZram = true }) =>
      isZram &&
      css`
        @media ${mediaBreakpointMixin('xl')} {
          padding: ${spaceMixin('sm')};
        }
      `}
  }
`;

export const StyledTableHeaderRow = styled(Table.Row)`
  display: flex;
  max-width: 1232px;
  margin: auto;
`;
